import Component from 'antd/es/auto-complete';
import 'antd/lib/auto-complete/style';
export default Component;
